import React from 'react';
import { Player } from '../../types';
import { getPlayerDisplayName } from '../../utils/playerUtils';
import { PANEL_STYLES, SUBHEADING_STYLES } from '../../constants/styles';

interface WaitingMessageProps {
  currentPlayer: Player;
  players: Player[];
}

export const WaitingMessage: React.FC<WaitingMessageProps> = ({
  currentPlayer,
  players,
}) => {
  return (
    <div className={`${PANEL_STYLES} text-center`}>
      <p className={SUBHEADING_STYLES}>
        Waiting for {getPlayerDisplayName(currentPlayer.name, players)}...
      </p>
    </div>
  );
};

interface LastActionProps {
  lastAction: string;
}

export const LastAction: React.FC<LastActionProps> = ({ lastAction }) => {
  return (
    <div className="bg-surface-50 dark:bg-gray-700 rounded shadow p-2 text-center flex-shrink-0">
      <p className="text-xs text-gray-700 dark:text-gray-300">{lastAction}</p>
    </div>
  );
};